import { Layout } from 'antd';
import React from 'react';
import ProfileListHeader from '../header-profile-list';
import Profile from '../profile';
import styles from './styles.module.scss';

const { Content } = Layout;
interface EmployeeListProps {
  employeeList: any;
}
const style: React.CSSProperties = { background: '#0092ff', padding: '8px 0' };

const ProfileList: React.FC<EmployeeListProps> = ({
  employeeList,
}: EmployeeListProps): JSX.Element => {
  return (
    <>
      <Layout className={styles.layout}>
        <Content className={styles.container}>
          <div style={{ minWidth: '1000px' }}>
            <ProfileListHeader />
            {employeeList.map((employee: any, index: number) => {
              return <Profile {...{ employee: employee }} key={index} />;
            })}
          </div>
        </Content>
      </Layout>
    </>
  );
};

export default ProfileList;
